import React from 'react';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  initials: 'CG',
  name: 'Carlos G.',
  role: '📍 Buenos Aires | Docente de Física Secundaria',
  quote: 'Compré el MegaPack un domingo a la noche. El lunes tenía todo el año de Física organizado. Las fichas ilustradas son exactamente lo que mis alumnos necesitaban para entender las fórmulas sin que parezca un libro de texto.'
}, {
  initials: 'MG',
  name: 'Mariana G.',
  role: '📍 GBA | Docente de Física Secundaria',
  quote: 'El Tomo 7 me salvó la Muestra Anual. El brazo hidráulico con jeringas quedó perfecto y mis alumnos lo explicaron solos con el guión que venía incluido. El jurado quedó impresionado.'
}, {
  initials: 'LG',
  name: 'Laura G.',
  role: '📍 Córdoba | Profesora de Física y Química',
  quote: 'Lo que más valoro es que está organizado POR AÑO. No tengo que adivinar qué le corresponde a cada curso. Todo ya está pensado, ordenado y alineado al diseño curricular. Mis colegas me preguntaron cómo preparé todo tan bien.'
}, {
  initials: 'AT',
  name: 'Alejandra T.',
  role: '📍 Santa Fe | Docente de Física Secundaria',
  quote: 'Los experimentos de bajo costo del Tomo 3 me cambiaron la vida. Medir g con el celular y verificar MRU en el patio me dio clases que mis alumnos todavía recuerdan. Y costó menos de $1.000 ARS hacerlo.'
}, {
  initials: 'RS',
  name: 'Roberto S.',
  role: '📍 Mendoza | Docente de Física Secundaria',
  quote: 'Las evaluaciones del Pack VIP me cambiaron la corrección. Con los Temas A y B nunca más tuve problemas de copia. Y las rúbricas me sacan de cualquier discusión con alumnos o padres sobre las notas.'
}, {
  initials: 'PA',
  name: 'Patricia A.',
  role: '📍 Tucumán | Docente Secundaria',
  quote: 'Llegué a marzo con todo listo por primera vez en 10 años de docencia. Los solucionarios docentes me ahorran 2 horas de corrección por semana. Mis colegas me piden que les pase el material y les digo que lo compren.'
}];
export function FullTestimonials() {
  return <section className="py-10 md:py-20 px-4 bg-white" data-id="element-138">
      <div className="max-w-4xl mx-auto" data-id="element-139">
        <h2 className="text-3xl md:text-4xl font-black text-center text-brand-dark mb-8 md:mb-16" data-id="element-140">
          Lo que dicen los docentes de Física <br className="hidden md:block" data-id="element-141" />
          <span className="text-brand-blue" data-id="element-142">que ya tienen su MegaPack:</span>
        </h2>

        <div className="space-y-5 md:space-y-8" data-id="element-143">
          {testimonials.map((t, i) => <div key={i} className="bg-brand-gray p-8 rounded-2xl shadow-md border border-gray-200" data-id="element-144">
              <div className="flex flex-col md:flex-row gap-6 items-start" data-id="element-145">
                <div className="flex-shrink-0 flex flex-col items-center" data-id="element-146">
                  <div className="w-16 h-16 bg-brand-blue text-white rounded-full flex items-center justify-center text-xl font-bold mb-3" data-id="element-147">
                    {t.initials}
                  </div>
                  <div className="flex text-yellow-400" data-id="element-148">
                    {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-current" data-id="element-149" />)}
                  </div>
                </div>
                <div data-id="element-150">
                  <h4 className="text-xl font-bold text-brand-dark mb-1" data-id="element-151">
                    {t.name}
                  </h4>
                  <p className="text-sm text-gray-500 font-medium mb-4" data-id="element-152">
                    {t.role}
                  </p>
                  <p className="text-lg text-gray-700 leading-relaxed italic" data-id="element-153">
                    "{t.quote}"
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}